import { ReactComponent as LogoWhite } from "./svg/logo_horizontal.svg";
import { ReactComponent as Rejected } from "./svg/stroke.svg";
import { ReactComponent as Pending } from "./svg/pending.svg";

import separator from "./png/separator.png";
import logOut from "./png/log-out.png";
import search from "./png/search.png";

import gateway from "./svg/gateway.svg";
import subsidio from "./svg/supersubsidio.svg";
import info from "./svg/info.svg";
import vigilado from "./svg/vigilado.svg";

const Icon = {
  LogoWhite,
  Rejected,
  Pending
};

const image = {
  vigilado,
  separator,
  gateway,
  logOut,
  subsidio,
  search,
  info
};

export { Icon, image };
